import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-sections-list"
}
const _hoisted_2 = { class: "app-section-info" }
const _hoisted_3 = { class: "app-section-title-row" }
const _hoisted_4 = { class: "app-section-key" }
const _hoisted_5 = { class: "app-section-role" }
const _hoisted_6 = { class: "app-section-controls" }
const _hoisted_7 = { class: "app-section-toggle" }
const _hoisted_8 = {
  key: 1,
  class: "admin-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Разделы приложения",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("Доступ к разделам приложения", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("p", { class: "admin-card-subtitle" }, " Включите «Доступно всем» для публичных разделов или выберите роль, которая открывает закрытый раздел. ", -1)),
                  (_ctx.sections.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: section.sectionKey,
                            class: "app-section-row"
                          }, [
                            _createElementVNode("div", _hoisted_2, [
                              _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("h3", null, _toDisplayString(section.name), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(['app-section-status', section.availableToAll ? 'app-section-status--public' : 'app-section-status--role'])
                                }, _toDisplayString(section.availableToAll ? 'Доступно всем' : 'По роли'), 3)
                              ]),
                              _createElementVNode("p", _hoisted_4, _toDisplayString(section.sectionKey), 1),
                              _createElementVNode("p", _hoisted_5, _toDisplayString(section.availableToAll ? 'Раздел виден всем пользователям' : _ctx.roleLabel(section.roleName)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("label", _hoisted_7, [
                                _cache[1] || (_cache[1] = _createElementVNode("span", null, "Доступно всем", -1)),
                                _createVNode(_component_ion_toggle, {
                                  modelValue: section.availableToAll,
                                  "onUpdate:modelValue": ($event: any) => ((section.availableToAll) = $event),
                                  mode: "ios",
                                  onIonChange: ($event: any) => (_ctx.saveSection(section))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonChange"])
                              ]),
                              _createVNode(_component_ion_item, {
                                lines: "none",
                                class: _normalizeClass(['app-section-role-select', { 'app-section-role-select--disabled': section.availableToAll }])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_select, {
                                    label: "Роль доступа",
                                    "label-placement": "stacked",
                                    modelValue: section.roleName,
                                    "onUpdate:modelValue": ($event: any) => ((section.roleName) = $event),
                                    interface: "popover",
                                    "interface-options": _ctx.roleSelectPopoverOptions,
                                    mode: "ios",
                                    placeholder: "Выберите роль",
                                    disabled: section.availableToAll,
                                    onIonChange: ($event: any) => (_ctx.saveSection(section))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAuthorities, (a) => {
                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                          key: a.name,
                                          value: a.name
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(a.description || a.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onUpdate:modelValue", "interface-options", "disabled", "onIonChange"])
                                ]),
                                _: 2
                              }, 1032, ["class"])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_8, "Разделы приложения не загружены."))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"])
    ]),
    _: 1
  }))
}